var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
//TODO: remove references to model.ts
import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class DailyResultsDTO {
    static { this.plainSerializable = true; }
    constructor(props) {
        this.employeeId = undefined;
        safeAssign(this, props);
    }
    static fromEntity(e) {
        const dto = Object.create(DailyResultsDTO.prototype);
        dto.employeeId = e.employeeId;
        dto.date = e.date;
        dto.bonusesBalance = e.bonusesBalance;
        dto.timeBalance = e.timeBalance;
        dto.timeBalancePlanned = e.timeBalancePlanned;
        dto.vacationBalance = e.vacationBalance;
        dto.issues = e.issues;
        dto.averages = e.averages;
        dto.results = e.results;
        return dto;
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DailyResultsDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "bonusesBalance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "timeBalance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "timeBalancePlanned", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "vacationBalance", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "issues", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "averages", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DailyResultsDTO.prototype, "results", void 0);
//# sourceMappingURL=daily-results.dto.js.map